import AdminUserListReducer from './AdminUserListReducer';

export default from './AdminUserListContainer';
export const AdminUserListReducers = {
  AdminUserListReducer,
};
